import styled, { css } from 'styled-components';

export const CustomImage = styled.img`
    width: ${props => props.width};
    height: ${props => props.height};
    cursor: ${props => props.cursor};
    position: ${props => props.position};
    right: ${props => props.right};
    top: ${props => props.top};
    left: ${props => props.left};
    display: ${props => props.display};
    justify-content: ${props => props.justifyContent};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

export const dropdownLegendTemplate = css`
    span {
        background-color: ${({ legendColor }) => legendColor};
        width: 20px;
        height: 4px;
        border-radius: 10px;
        display: inline-block;
        margin: 0 8px 0 0;
    }
`;
